import Extend from 'flarum/common/extenders';
import Tag from './models/Tag';
import Discussion from 'flarum/common/models/Discussion';

export default [
  new Extend.Store() //
    .add('tags', Tag),
  new Extend.Model(Discussion) //
    .hasMany<Tag>('tags'), //
];
